/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

const NOTIFICATION_SET = 'NOTIFICATION_SET';
const NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';

const state = {
  notification: null
};

const mutations = {
  [NOTIFICATION_SET] (state, notification) {
    state.notification = notification;
  },

  [NOTIFICATION_CLEAR] (state) {
    state.notification = null;
  }
};

const actions = {
  notify: ({ commit }, notification) => {
    commit(NOTIFICATION_SET, notification);
  },
  clearNotification: ({ state, commit }) => {
    if (!state.notification) {
      return;
    }
    commit(NOTIFICATION_CLEAR);
  }
};

const getters = {
  notification: state => state.notification
};

export default {
  state,
  mutations,
  actions,
  getters
};
